/* lp-free-ship.js — the add button in the cart's free-shipping line (snippets/lp-free-ship-add.liquid). It adds through
   lp-cart.js, the same request and CartLinesUpdateEvent as the shelf and the product page, so Horizon re-renders the
   drawer, and the line with it, from the server. Without lp-cart.js the form simply posts to /cart/add. 19 Oct 2026.
   After the same-day review: a refused add (sold out, a limit) gives the button back with a short message, and a
   successful one moves focus to the new line, because the button that had focus is gone after the re-render. */
(function () {
  'use strict';
  if (window.__lpFreeShip) return;
  window.__lpFreeShip = true;
  function giveBack(form, btn, text) {
    btn.disabled = false;
    var row = form.closest('.lpfs__add');
    if (!row || row.querySelector('.lpfs__err')) return;
    var p = document.createElement('p');
    p.className = 'lpfs__err';
    p.setAttribute('role', 'alert');
    p.textContent = text;
    row.appendChild(p);
  }
  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('form[data-lpfs-form]') : null;
    if (!form || typeof window.lpCartAdd !== 'function') return;   /* no lp-cart.js: the plain post goes ahead */
    e.preventDefault();
    var btn = form.querySelector('[data-lpfs-add]');
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    var where = form.closest('.lpfs--page') ? '.lpfs--page' : '.lpfs--drawer';
    window.lpCartAdd(form, btn.getAttribute('data-lpfs-add'), 1, btn.getAttribute('data-product-id'))
      .then(function (ok) {
        if (ok === false) { giveBack(form, btn, 'Sorry, that one can’t be added right now.'); return; }
        setTimeout(function () {
          var line = document.querySelector(where + ' .lpfs__line');
          if (line) { line.setAttribute('tabindex', '-1'); line.focus({ preventScroll: true }); }
        }, 400);
      })
      .catch(function (err) {
        giveBack(form, btn, 'Sorry, that one can’t be added right now.');
        if (window.console) console.error('lp-free-ship: add failed', err);
      });
  });
})();
